(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-products"] && !Shopify.designMode) return;
  try {
    (function () {
    // ---- Delete button (moved from cart-product-card.liquid) ----
    // Dispatches quantity -> 0 THROUGH the existing quantity-selector /
    // cart-items-component pipeline, so removal gets the same section
    // morph as +/-, keeping price, free-shipping bar, and confetti tier
    // in sync with no separate network call.
    if (!window.__cartCardDeleteListenerAttached) {
      window.__cartCardDeleteListenerAttached = true;

      document.addEventListener('click', function (e) {
        var removeBtn = e.target.closest('[data-cart-remove]');
        if (!removeBtn) return;

        var card = removeBtn.closest('[data-cart-card]');
        if (!card) return;

        var selector = card.querySelector('cart-quantity-selector-component');
        if (!selector || typeof selector.setValue !== 'function' || typeof selector.onQuantityChange !== 'function') {
          return;
        }

        selector.setValue('0');
        selector.onQuantityChange();
      });
    }



    // ---- Inventory-aware quantity controls (v3) ----
    // Shopify's native quantity-selector remains responsible for cart updates.
    // This layer only enables/disables +/- using REAL inventory that Liquid
    // renders into <script data-cart-inventory-map> (see markup above).
    //
    // Why not /products/<handle>.js any more: that public endpoint does not
    // return inventory_quantity, so the old v2 guard always ended up with
    // max = current quantity and the "+" button was permanently disabled.
    //
    // Rules:
    //   - Inventory not tracked            -> unlimited (no max)
    //   - Policy "continue" (oversell on)  -> unlimited (no max)
    //   - Tracked + policy "deny"          -> max = inventory_quantity
    //   - quantity_rule.max (B2B / rules)  -> also respected if set
    if (!window.__cartQuantityInventoryGuardV3) {
      window.__cartQuantityInventoryGuardV3 = true;

      var readInventoryMap = function (scope) {
        var el = scope.querySelector('script[data-cart-inventory-map]');
        if (!el) return null;
        try {
          var data = JSON.parse(el.textContent || '[]');
          return Array.isArray(data) ? data : null;
        } catch (err) {
          return null;
        }
      };

      // Returns Infinity when the line has no stock limit.
      var getLineLimit = function (entry) {
        var limit = Infinity;

        if (entry.tracked === true && entry.policy !== 'continue') {
          var available = Number(entry.available);
          if (Number.isFinite(available)) limit = Math.max(0, available);
        }

        if (entry.rule_max !== null && entry.rule_max !== undefined && entry.rule_max !== '') {
          var ruleMax = Number(entry.rule_max);
          if (Number.isFinite(ruleMax) && ruleMax > 0) limit = Math.min(limit, ruleMax);
        }

        return limit;
      };

      // Try to match a quantity selector to its cart line by line key
      // first (robust), then fall back to render order (same loop).
      var findEntry = function (map, selector, index) {
        var card = selector.closest('[data-cart-card]');
        var input = selector.querySelector('input');
        var key =
          (card && (card.getAttribute('data-key') || card.getAttribute('data-line-key') || card.getAttribute('data-cart-line-key'))) ||
          selector.getAttribute('data-key') ||
          selector.getAttribute('data-line-key') ||
          (input && (input.getAttribute('data-key') || input.getAttribute('data-line-key'))) ||
          '';

        if (key) {
          for (var i = 0; i < map.length; i++) {
            if (map[i] && map[i].key === key) return map[i];
          }
        }

        return map[index] || null;
      };

      var syncQuantityButtons = function () {
        var wrappers = document.querySelectorAll('.cart-items__wrapper');

        for (var w = 0; w < wrappers.length; w++) {
          var wrapperEl = wrappers[w];
          var map = readInventoryMap(wrapperEl);
          var selectors = wrapperEl.querySelectorAll('.cart-form cart-quantity-selector-component');

          for (var i = 0; i < selectors.length; i++) {
            var selector = selectors[i];
            var input = selector.querySelector('.cart-card__qty-value, input[type="number"], input');
            if (!input) continue;

            var minAttr = input.getAttribute('min');
            var minimum = minAttr === null || minAttr === '' ? 1 : Number(minAttr);
            if (!Number.isFinite(minimum) || minimum < 1) minimum = 1;

            var quantity = Number(input.value);
            if (!Number.isFinite(quantity)) quantity = minimum;

            // Minus: disabled only at the minimum (delete button handles removal).
            var minusButton = selector.querySelector('.cart-card__qty-minus');
            if (minusButton) {
              var disableMinus = quantity <= minimum;
              minusButton.disabled = disableMinus;
              minusButton.setAttribute('aria-disabled', disableMinus ? 'true' : 'false');
            }

            var plusButton = selector.querySelector('.cart-card__qty-plus');
            var entry = map ? findEntry(map, selector, i) : null;

            // No data for this line -> leave Shopify's own behaviour alone,
            // but never leave the "+" stuck because of an old guard.
            if (!entry) {
              if (plusButton && plusButton.getAttribute('data-inventory-locked') === 'true') {
                plusButton.disabled = false;
                plusButton.setAttribute('aria-disabled', 'false');
                plusButton.removeAttribute('data-inventory-locked');
              }
              continue;
            }

            var limit = getLineLimit(entry);

            if (limit === Infinity) {
              input.removeAttribute('max');
            } else {
              // Never set max below the quantity already in the cart, or the
              // input becomes invalid.
              input.setAttribute('max', String(Math.max(limit, quantity)));
            }

            selector.dataset.inventoryMax = limit === Infinity ? '' : String(limit);

            if (plusButton) {
              var disablePlus = limit !== Infinity && quantity >= limit;
              plusButton.disabled = disablePlus;
              plusButton.setAttribute('aria-disabled', disablePlus ? 'true' : 'false');
              if (disablePlus) {
                plusButton.setAttribute('data-inventory-locked', 'true');
                plusButton.setAttribute('title', 'Only ' + limit + ' in stock');
              } else {
                plusButton.removeAttribute('data-inventory-locked');
                plusButton.removeAttribute('title');
              }
            }
          }
        }
      };

      var syncFrame = null;
      var scheduleSync = function () {
        if (syncFrame) return;
        syncFrame = window.requestAnimationFrame(function () {
          syncFrame = null;
          syncQuantityButtons();
        });
      };

      document.addEventListener('input', function (event) {
        if (event.target && event.target.closest && event.target.closest('cart-quantity-selector-component')) {
          scheduleSync();
        }
      });

      document.addEventListener('change', function (event) {
        if (event.target && event.target.closest && event.target.closest('cart-quantity-selector-component')) {
          scheduleSync();
        }
      });

      // Re-check right after +/- clicks (the theme may update the value
      // without firing an input event).
      document.addEventListener('click', function (event) {
        if (event.target && event.target.closest && event.target.closest('.cart-card__qty-btn')) {
          window.setTimeout(scheduleSync, 0);
        }
      });

      // Cart section re-renders (add / +/- / remove / morph) bring a fresh
      // inventory map, so just re-sync. No network requests here.
      var quantityObserver = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var m = mutations[i];
          if (m.type !== 'childList' || !m.addedNodes.length) continue;

          var target = m.target;
          if (
            target &&
            target.closest &&
            (target.closest('.cart-items__wrapper') || target.querySelector && target.querySelector('.cart-items__wrapper'))
          ) {
            scheduleSync();
            return;
          }
        }
      });

      quantityObserver.observe(document.body, { childList: true, subtree: true });

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', scheduleSync);
      } else {
        scheduleSync();
      }

      window.__refreshCartQuantityLimits = scheduleSync;
    }

    // ---- Free-shipping confetti ----
    // v6: only one reward now — 0 -> 1 = FREE Shipping unlocked (₹1,999).
    // If the cart jumps across multiple thresholds in one update, every
    // crossed reward gets its own celebration wave.
    if (!window.__cartProgressConfettiInitV5) {
      window.__cartProgressConfettiInitV5 = true;

      var STORAGE_KEY = 'cartProgressTierV6';
      var confettiColors = [
        '#00675b', '#0d806f', '#d8ae43', '#df7a61',
        '#3d9a8b', '#efd08d', '#bd5650', '#78a9a2'
      ];
      var shapeVariants = ['rect', 'strip', 'triangle', 'irregular'];

      var randomBetween = function (min, max) {
        return min + Math.random() * (max - min);
      };

      var prefersReducedMotion = function () {
        return window.matchMedia &&
          window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      };

      var spawnConfetti = function (progressEl, waveNumber) {
        if (prefersReducedMotion() || !progressEl) return;

        var root = progressEl.closest('.cart-items__wrapper');
        if (!root) return;

        var host = root.querySelector(':scope > .cart-progress__confetti');
        if (!host) return;

        var rect = host.getBoundingClientRect();
        if (!rect.width) return;

        /*
         * Keep all three celebrations in the same cart-local layer.
         * waveNumber slightly changes the launch position so the 3 rewards
         * feel like three separate bursts instead of one giant explosion.
         */
        var launchOffset = waveNumber === 1
          ? randomBetween(-rect.width * 0.12, rect.width * 0.12)
          : waveNumber === 2
            ? randomBetween(-rect.width * 0.20, rect.width * 0.20)
            : randomBetween(-rect.width * 0.28, rect.width * 0.28);

        var pieceCount = Math.min(
          105,
          Math.max(78, Math.round(rect.width / 3.8))
        );

        for (var i = 0; i < pieceCount; i++) {
          var piece = document.createElement('span');
          var shape = shapeVariants[
            Math.floor(Math.random() * shapeVariants.length)
          ];
          var color = confettiColors[
            Math.floor(Math.random() * confettiColors.length)
          ];

          piece.className =
            'cart-progress__confetti-piece cart-progress__confetti-piece--' + shape;

          var startX = launchOffset +
            randomBetween(-rect.width * 0.46, rect.width * 0.46);
          var midX = randomBetween(-28, 28);
          var dx = randomBetween(-62, 62);

          piece.style.left = '50%';

          var width;
          var height;

          if (shape === 'strip') {
            width = randomBetween(2, 3.5);
            height = randomBetween(7, 13);
          } else if (shape === 'triangle') {
            var triSize = randomBetween(5, 8);
            piece.style.borderLeft =
              (triSize / 2) + 'px solid transparent';
            piece.style.borderRight =
              (triSize / 2) + 'px solid transparent';
            piece.style.borderBottom =
              triSize + 'px solid ' + color;
          } else if (shape === 'irregular') {
            width = randomBetween(4, 8);
            height = randomBetween(4, 8);
          } else {
            width = randomBetween(3, 7);
            height = randomBetween(5, 10);
          }

          if (shape !== 'triangle') {
            piece.style.width = width + 'px';
            piece.style.height = height + 'px';
            piece.style.background = color;
          }

          var midY = randomBetween(72, 135);
          var minEnd = Math.min(
            300,
            Math.max(245, rect.height * 0.60)
          );
          var maxEnd = Math.max(330, rect.height - 8);
          var dy = randomBetween(minEnd, maxEnd);
          var rot = randomBetween(280, 700) *
            (Math.random() < 0.5 ? -1 : 1);
          var midRot = randomBetween(80, 190) *
            (Math.random() < 0.5 ? -1 : 1);

          piece.style.setProperty('--cp-start-x', startX + 'px');
          piece.style.setProperty('--cp-mid-x', midX + 'px');
          piece.style.setProperty('--cp-mid-y', midY + 'px');
          piece.style.setProperty('--cp-mid-rot', midRot + 'deg');
          piece.style.setProperty('--cp-dx', dx + 'px');
          piece.style.setProperty('--cp-dy', dy + 'px');
          piece.style.setProperty('--cp-rot', rot + 'deg');

          piece.style.animationDuration =
            randomBetween(2.35, 3.35) + 's';

          /*
           * Each reward gets its own wave:
           * wave 1 starts immediately,
           * wave 2 follows shortly,
           * wave 3 follows after that.
           */
          var baseDelay = waveNumber === 1
            ? 0
            : waveNumber === 2
              ? 0.42
              : 0.84;

          piece.style.animationDelay =
            (baseDelay + randomBetween(0, 0.45)) + 's';

          host.appendChild(piece);
        }
      };

      var celebrateCrossedRewards = function (progressEl, oldTier, newTier) {
        if (!progressEl || newTier <= oldTier) return;

        var crossed = newTier - oldTier;

        /*
         * 3 -> 0 never happens here because this is only called for upward
         * changes. A direct jump 0 -> 3 therefore produces three waves.
         */
        for (var i = 1; i <= crossed; i++) {
          (function (wave) {
            window.setTimeout(function () {
              spawnConfetti(progressEl, wave);
            }, (wave - 1) * 420);
          })(i);
        }

        window.setTimeout(function () {
          var root = progressEl.closest('.cart-items__wrapper');
          var host = root &&
            root.querySelector(':scope > .cart-progress__confetti');

          if (host) host.innerHTML = '';
        }, 4800 + (crossed * 250));
      };

      var checkTierChange = function (progressEl) {
        var tier =
          parseInt(progressEl.getAttribute('data-current-tier'), 10) || 0;

        var storedRaw = sessionStorage.getItem(STORAGE_KEY);

        if (storedRaw === null) {
          sessionStorage.setItem(STORAGE_KEY, String(tier));
          return;
        }

        var storedTier = parseInt(storedRaw, 10) || 0;

        if (tier > storedTier) {
          celebrateCrossedRewards(progressEl, storedTier, tier);
        }

        /*
         * Always sync the stored tier, including downward changes.
         * This means if the shopper goes from 3 back to 0 and later climbs
         * through the rewards again, each reward celebrates again.
         */
        if (tier !== storedTier) {
          sessionStorage.setItem(STORAGE_KEY, String(tier));
        }
      };

      var findProgress = function () {
        return document.querySelector(
          '.cart-progress[data-current-tier]'
        );
      };

      var initialEl = findProgress();
      if (initialEl) checkTierChange(initialEl);

      var runTierCheck = function () {
        if (window.__cartProgressObserverFrameV7) return;

        window.__cartProgressObserverFrameV7 =
          window.requestAnimationFrame(function () {
            window.__cartProgressObserverFrameV7 = null;

            var el = findProgress();
            if (el) checkTierChange(el);
          });
      };

      /*
       * IMPORTANT:
       * Do not stop watching after the first cart render.
       *
       * When the cart starts empty, .cart-items__wrapper does not exist yet.
       * When Shopify later adds the first product, it can also replace the
       * cart section. A short retry loop is therefore not reliable.
       *
       * This stable document-level observer watches for the cart section to
       * appear/reappear and also catches data-current-tier changes after
       * every add, quantity change, remove, and section morph.
       */
      var documentCartObserver = new MutationObserver(function (mutations) {
        var shouldCheck = false;

        for (var i = 0; i < mutations.length; i++) {
          var mutation = mutations[i];

          if (mutation.type === 'childList') {
            shouldCheck = true;
            break;
          }

          if (
            mutation.type === 'attributes' &&
            mutation.attributeName === 'data-current-tier'
          ) {
            shouldCheck = true;
            break;
          }
        }

        if (shouldCheck) runTierCheck();
      });

      documentCartObserver.observe(document.documentElement, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['data-current-tier']
      });

      /*
       * Check immediately on initial page load.
       */
      runTierCheck();

      /*
       * Also expose a tiny helper so any Shopify cart section replacement
       * can explicitly request a tier check without needing another page load.
       */
      window.__refreshCartRewardTierV7 = runTierCheck;
    }
  })();

  (function () {
    // ---- Inline coupons ----
    // Available coupons are read ONLY from shop.metafields.custom.available_coupons.
    // The same handler is used for a coupon card and the manual code field.
    if (!window.__inlineCouponCardsInitV3) {
      window.__inlineCouponCardsInitV3 = true;

      var getCartSectionId = function () {
        var host = document.querySelector('cart-items-component[data-section-id]');
        return host ? host.getAttribute('data-section-id') : null;
      };

      var getCurrentCart = function () {
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        return fetch(root + 'cart.js', { credentials: 'same-origin' })
          .then(function (res) {
            if (!res.ok) throw new Error('Cart read failed: ' + res.status);
            return res.json();
          });
      };

      var swapInFreshSectionHtml = function (html) {
        if (!html) return;

        var doc = new DOMParser().parseFromString(html, 'text/html');
        var liveItems = document.querySelector('.cart-items__wrapper');
        var freshItems = doc.querySelector('.cart-items__wrapper');

        if (freshItems && liveItems) {
          liveItems.innerHTML = freshItems.innerHTML;
        }

        var liveSummary = document.querySelector('.cart-drawer__summary');
        var freshSummary = doc.querySelector('.cart-drawer__summary');

        if (freshSummary && liveSummary) {
          liveSummary.innerHTML = freshSummary.innerHTML;
        }

        // Refresh the coupon area too, so automatic discounts and newly
        // applied discount codes appear immediately in the same UI.
        var liveCoupons = document.querySelector('.cart-coupons-wrapper');
        var freshCoupons = doc.querySelector('.cart-coupons-wrapper');

        if (freshCoupons && liveCoupons) {
          liveCoupons.innerHTML = freshCoupons.innerHTML;
        }

        // v3: re-apply stock limits to the freshly swapped-in cards.
        if (typeof window.__refreshCartQuantityLimits === 'function') {
          window.__refreshCartQuantityLimits();
        }
      };

      var updateDiscount = function (discountValue) {
        var sectionId = getCartSectionId();
        var body = { discount: discountValue };
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

        if (sectionId) {
          body.sections = sectionId;
          body.sections_url = window.location.pathname;
        }

        return fetch(root + 'cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body),
        })
          .then(function (res) {
            return res.json().then(function (data) {
              if (!res.ok) {
                var message = data && (data.description || data.message);
                throw new Error(message || ('Coupon request failed: ' + res.status));
              }
              return data;
            });
          })
          .then(function (data) {
            if (sectionId && data.sections && data.sections[sectionId]) {
              swapInFreshSectionHtml(data.sections[sectionId]);
            }
            return data;
          });
      };

      var copyText = function (text) {
        if (!text) return Promise.resolve();

        if (navigator.clipboard && navigator.clipboard.writeText) {
          return navigator.clipboard.writeText(text).catch(function () {
            var textarea = document.createElement('textarea');
            textarea.value = text;
            textarea.style.position = 'fixed';
            textarea.style.opacity = '0';
            document.body.appendChild(textarea);
            textarea.focus();
            textarea.select();
            try { document.execCommand('copy'); } catch (err) {}
            document.body.removeChild(textarea);
          });
        }

        var textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();
        try { document.execCommand('copy'); } catch (err) {}
        document.body.removeChild(textarea);
        return Promise.resolve();
      };

      var setMessage = function (message, isError) {
        var messageEl = document.querySelector('[data-inline-coupon-message]');
        if (!messageEl) return;
        messageEl.textContent = message || '';
        messageEl.style.color = isError ? '#b3261e' : '#4c7c68';
      };

      var hasAppliedDiscount = function (cart, beforeCart) {
        if (!cart) return false;

        if (Number(cart.total_discount || 0) > Number(beforeCart && beforeCart.total_discount || 0)) {
          return true;
        }

        if (Array.isArray(cart.cart_level_discount_applications) && cart.cart_level_discount_applications.length) {
          return true;
        }

        if (Array.isArray(cart.items)) {
          for (var i = 0; i < cart.items.length; i++) {
            var item = cart.items[i];
            if (Number(item.line_level_total_discount || 0) > 0) return true;
            if (Array.isArray(item.line_level_discount_allocations) && item.line_level_discount_allocations.length) {
              return true;
            }
          }
        }

        return false;
      };

      var removeAppliedCoupon = function (buttonEl) {
        if (buttonEl) buttonEl.disabled = true;
        setMessage('Removing coupon…', false);

        return updateDiscount('')
          .then(function () {
            return getCurrentCart();
          })
          .then(function (cart) {
            if (hasAppliedDiscount(cart, null)) {
              setMessage('This discount is applied automatically and cannot be removed manually.', true);
              return;
            }

            setMessage('Coupon removed. Available coupons are shown again.', false);
          })
          .catch(function (error) {
            console.error('Coupon remove failed:', error);
            setMessage(error && error.message ? error.message : 'Unable to remove coupon.', true);
          })
          .finally(function () {
            if (buttonEl && buttonEl.isConnected) buttonEl.disabled = false;
          });
      };

      var applyCoupon = function (code, buttonEl, messageMode) {
        var trimmed = (code || '').trim().toUpperCase();
        if (!trimmed) {
          if (messageMode) setMessage('Please enter a coupon code.', true);
          return Promise.reject(new Error('Empty coupon code'));
        }

        if (buttonEl) buttonEl.disabled = true;
        if (messageMode) setMessage('Checking coupon…', false);

        return getCurrentCart()
          .then(function (beforeCart) {
            return copyText(trimmed)
              .then(function () {
                return updateDiscount(trimmed);
              })
              .then(function (updateResult) {
                // Shopify's Cart AJAX API accepts { discount: 'CODE' } on
                // /cart/update.js. We then read the cart again so we can
                // distinguish a real applied discount from a code that is
                // invalid, inactive, or currently not eligible.
                return getCurrentCart().then(function (afterCart) {
                  if (!hasAppliedDiscount(afterCart, beforeCart)) {
                    throw new Error('Coupon is invalid or not applicable to this cart.');
                  }

                  return updateResult;
                });
              });
          })
          .then(function () {
            setMessage('Coupon applied successfully. Your cart total has been updated.', false);

            document.querySelectorAll('[data-inline-coupon-apply]').forEach(function (btn) {
              var btnCode = (btn.getAttribute('data-coupon-code') || '').trim().toUpperCase();
              if (btnCode === trimmed) {
                var textEl = btn.querySelector('.cart-coupon-card__copy-text');
                if (textEl) textEl.textContent = 'APPLIED';
              }
            });

            return true;
          })
          .catch(function (err) {
            console.error('Coupon apply failed:', err);
            setMessage('Enter a valid active coupon code that applies to your cart.', true);
            throw err;
          })
          .finally(function () {
            if (buttonEl && buttonEl.isConnected) buttonEl.disabled = false;
          });
      };

      document.addEventListener('click', function (e) {
        var removeButton = e.target.closest('[data-inline-coupon-remove]');
        if (removeButton) {
          e.preventDefault();
          e.stopPropagation();
          removeAppliedCoupon(removeButton);
          return;
        }

        var button = e.target.closest('[data-inline-coupon-apply]');
        if (!button) return;

        var code = button.getAttribute('data-coupon-code') || '';
        applyCoupon(code, button, true).catch(function () {});
      });

      document.addEventListener('submit', function (e) {
        var form = e.target.closest('[data-inline-coupon-form]');
        if (!form) return;

        e.preventDefault();

        var input = form.querySelector('[data-inline-coupon-input]');
        var submit = form.querySelector('[data-inline-coupon-submit]');
        var code = input ? input.value.trim() : '';

        applyCoupon(code, submit, true)
          .then(function () {
            if (input) input.value = '';
          })
          .catch(function () {});
      });
    }
  })();
  (function () {
    // ---- Cart summary expand/collapse (moved from cart-summary.liquid) ----
    if (!window.__cartSummaryToggleInit) {
      window.__cartSummaryToggleInit = true;

      document.addEventListener('click', function (e) {
        var toggle = e.target.closest('[data-cart-summary-toggle]');
        if (!toggle) return;

        var targetId = toggle.getAttribute('aria-controls');
        var panel = targetId ? document.getElementById(targetId) : null;
        if (!panel) return;

        var isExpanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
        panel.hidden = isExpanded;
      });
    }
  })();

  (function () {
    // ---- v4: "Build Your Motherhood Kit" upsell ----
    // - "+ ADD" on a single-variant product adds it straight to the cart.
    // - "+ ADD" on a multi-variant product opens the "Choose Option" sheet;
    //   shopper taps Add on one or more options, then Confirm.
    // - Adds go through /cart/add.js with Section Rendering, then the theme's
    //   own `cart:update` event refreshes the drawer, bubble, totals,
    //   free-shipping bar etc. A manual swap is used only as a fallback.
    //   No page refresh at any point.
    if (window.__cartUpsellKitV1) return;
    window.__cartUpsellKitV1 = true;

    var ICON_PLUS = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" aria-hidden="true"><path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
    var ICON_MINUS = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" aria-hidden="true"><path d="M5 12h14" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
    var ICON_CHECK = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    var ICON_BACK = '<svg viewBox="0 0 24 24" width="24" height="24" fill="none" aria-hidden="true"><path d="M20 12H5M11 6l-6 6 6 6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    var ICON_CLOSE = '<svg viewBox="0 0 24 24" width="24" height="24" fill="none" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';

    var shopRoot = function () {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    };

    var escapeHtml = function (value) {
      return String(value == null ? '' : value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    };

    var getCartSectionId = function () {
      var openWrapper = document.querySelector('dialog[open] .cart-items__wrapper');
      var host = (openWrapper && openWrapper.closest('[data-section-id]')) ||
        document.querySelector('cart-items-component[data-section-id]');
      return host ? host.getAttribute('data-section-id') : null;
    };

    var formatMoney = function (cents, fallback) {
      var amount = Number(cents) / 100;
      if (!Number.isFinite(amount)) return fallback || '';
      var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'INR';
      var hasPaise = Math.round(Number(cents)) % 100 !== 0;
      try {
        return new Intl.NumberFormat('en-IN', {
          style: 'currency',
          currency: currency,
          minimumFractionDigits: hasPaise ? 2 : 0,
          maximumFractionDigits: hasPaise ? 2 : 0
        }).format(amount);
      } catch (err) {
        return fallback || ('₹' + amount.toLocaleString('en-IN'));
      }
    };

    // Price shown in an option row = unit price x selected quantity.
    var linePriceText = function (variant, qty) {
      if (!qty || qty <= 1 || variant.price_cents == null) return variant.price;
      return formatMoney(Number(variant.price_cents) * qty, variant.price);
    };

    var readProduct = function (card) {
      var el = card && card.querySelector('script[data-upsell-json]');
      if (!el) return null;
      try {
        return JSON.parse(el.textContent);
      } catch (err) {
        return null;
      }
    };

    // ---------- Toast ----------
    var toastTimer = null;
    var showToast = function (container, message, isError) {
      container = container && container.isConnected ? container : document.body;
      var toast = container.querySelector(':scope > .cu-toast');
      if (!toast) {
        toast = document.createElement('div');
        toast.className = 'cu-toast' + (container !== document.body ? ' cu-toast--in-dialog' : '');
        toast.setAttribute('role', 'status');
        toast.setAttribute('aria-live', 'polite');
        container.appendChild(toast);
      }
      toast.textContent = message;
      toast.classList.toggle('cu-toast--error', !!isError);
      toast.classList.add('is-visible');
      window.clearTimeout(toastTimer);
      toastTimer = window.setTimeout(function () {
        toast.classList.remove('is-visible');
      }, 2600);
    };

    // ---------- Cart requests ----------
    var addItems = function (items) {
      var sectionId = getCartSectionId();
      var body = { items: items };

      if (sectionId) {
        body.sections = sectionId;
        body.sections_url = window.location.pathname;
      }

      return fetch(shopRoot() + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) {
            throw new Error((data && (data.description || data.message)) || 'Could not add this item.');
          }
          return data;
        });
      });
    };

    // v5: Update the OPEN cart drawer in place.
    // We no longer fire the theme's `cart:update` event for upsell adds:
    // that event makes the theme auto-open (= close + reopen) the drawer
    // and morph it at the same time, which left the drawer broken/empty.
    // Instead, only the CONTENTS inside the drawer are replaced; the
    // drawer <dialog> itself is never touched, so it stays open.
    var getDrawerScope = function () {
      var openWrapper = document.querySelector('dialog[open] .cart-items__wrapper');
      if (openWrapper) return openWrapper.closest('dialog');
      return document.querySelector('.cart-drawer__dialog') || document;
    };

    var swapInner = function (scope, doc, selector) {
      var live = scope.querySelector(selector);
      var fresh = doc.querySelector(selector);
      if (live && fresh) {
        live.innerHTML = fresh.innerHTML;
        return true;
      }
      return false;
    };

    var swapCartContents = function (html) {
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var scope = getDrawerScope();

      var scroller = scope.querySelector('.cart-drawer__content');
      var scrollTop = scroller ? scroller.scrollTop : 0;

      var liveSummary = scope.querySelector('.cart-drawer__summary');
      var freshSummary = doc.querySelector('.cart-drawer__summary');

      if (!liveSummary && freshSummary) {
        // Empty cart -> first item: the summary/checkout area doesn't exist
        // yet, so the drawer's inner content is replaced as one piece.
        if (swapInner(scope, doc, '.cart-drawer__inner')) {
          document.querySelectorAll('.cart-drawer--empty').forEach(function (el) {
            el.classList.remove('cart-drawer--empty');
          });
        }
      } else {
        swapInner(scope, doc, '.cart-items__wrapper');
        swapInner(scope, doc, '.cart-drawer__summary');
        swapInner(scope, doc, '.cart-drawer__heading');
      }

      var newScroller = scope.querySelector('.cart-drawer__content');
      if (newScroller) newScroller.scrollTop = scrollTop;
    };

    var updateCountBubbles = function (count) {
      document.querySelectorAll('.cart-bubble__text-count').forEach(function (el) {
        el.textContent = count > 0 ? String(count) : '';
      });
      document.querySelectorAll('.header-actions__cart-icon').forEach(function (el) {
        el.classList.toggle('header-actions__cart-icon--has-cart', count > 0);
        var bubble = el.querySelector('.cart-bubble');
        if (bubble && count > 0) {
          bubble.removeAttribute('hidden');
          bubble.classList.remove('visually-hidden');
        }
      });
    };

    var fetchSectionHtml = function (sectionId) {
      if (!sectionId) return Promise.resolve(null);
      var url = window.location.pathname + '?sections=' + encodeURIComponent(sectionId);
      return fetch(url, { credentials: 'same-origin' })
        .then(function (res) {
          return res.ok ? res.json() : null;
        })
        .then(function (data) {
          return data && data[sectionId] ? data[sectionId] : null;
        })
        .catch(function () {
          return null;
        });
    };

    var refreshCart = function (addResponse) {
      var sectionId = getCartSectionId();
      var sections = addResponse && addResponse.sections ? addResponse.sections : null;

      var htmlPromise = sections && sectionId && sections[sectionId]
        ? Promise.resolve(sections[sectionId])
        : fetchSectionHtml(sectionId);

      var cartPromise = fetch(shopRoot() + 'cart.js', { credentials: 'same-origin' })
        .then(function (res) {
          return res.json();
        })
        .catch(function () {
          return null;
        });

      return Promise.all([htmlPromise, cartPromise]).then(function (results) {
        var html = results[0];
        var cart = results[1];

        swapCartContents(html);
        if (cart) updateCountBubbles(cart.item_count);

        if (typeof window.__refreshCartQuantityLimits === 'function') {
          window.__refreshCartQuantityLimits();
        }
        if (typeof window.__refreshCartRewardTierV7 === 'function') {
          window.__refreshCartRewardTierV7();
        }
        scheduleArrows();
        return cart;
      });
    };

    // ---------- Card "+ ADD" button ----------
    var setCardButton = function (btn, state) {
      if (!btn || !btn.isConnected) return;
      var text = btn.querySelector('.cu-card__add-text');
      var icon = btn.querySelector('.cu-card__add-icon');

      btn.classList.remove('is-loading', 'is-added');
      btn.disabled = false;

      if (state === 'loading') {
        btn.classList.add('is-loading');
        btn.disabled = true;
        if (text) text.textContent = 'ADDING';
      } else if (state === 'added') {
        btn.classList.add('is-added');
        if (icon) icon.innerHTML = ICON_CHECK;
        if (text) text.textContent = 'ADDED';
      } else {
        if (icon) icon.innerHTML = ICON_PLUS;
        if (text) text.textContent = 'ADD';
      }
    };

    var handleCardAdd = function (btn) {
      var card = btn.closest('[data-upsell-card]');
      var product = readProduct(card);
      if (!product || !Array.isArray(product.variants)) return;

      var container = btn.closest('dialog') || document.body;
      var available = product.variants.filter(function (v) {
        return v.available;
      });

      if (!available.length) {
        showToast(container, 'This product is sold out.', true);
        return;
      }

      var isSingle = btn.getAttribute('data-single') === 'true' || product.variants.length === 1;

      if (!isSingle) {
        openSheet(product, container);
        return;
      }

      setCardButton(btn, 'loading');

      addItems([{ id: available[0].id, quantity: 1 }])
        .then(refreshCart)
        .then(function () {
          setCardButton(btn, 'added');
          showToast(container, 'Added to cart');
          window.setTimeout(function () {
            setCardButton(btn, 'idle');
          }, 1600);
        })
        .catch(function (err) {
          setCardButton(btn, 'idle');
          showToast(container, (err && err.message) || 'Could not add this item.', true);
        });
    };

    // ---------- "Choose Option" sheet ----------
    var sheet = null; // { host, product, selection, container }

    var findVariant = function (id) {
      if (!sheet) return null;
      for (var i = 0; i < sheet.product.variants.length; i++) {
        if (String(sheet.product.variants[i].id) === String(id)) return sheet.product.variants[i];
      }
      return null;
    };

    var renderAction = function (variant, qty) {
      if (!variant.available) {
        return '<button type="button" class="cu-opt__add" disabled>Sold out</button>';
      }
      if (qty > 0) {
        return (
          '<div class="cu-opt__stepper">' +
            '<button type="button" class="cu-opt__step" data-cu-step="-1" aria-label="Decrease quantity">' + ICON_MINUS + '</button>' +
            '<span class="cu-opt__qty">' + qty + '</span>' +
            '<button type="button" class="cu-opt__step" data-cu-step="1" aria-label="Increase quantity">' + ICON_PLUS + '</button>' +
          '</div>'
        );
      }
      return '<button type="button" class="cu-opt__add" data-cu-opt-add>Add</button>';
    };

    var renderRow = function (product, variant) {
      var img = variant.image
        ? '<img src="' + escapeHtml(variant.image) + '" alt="' + escapeHtml(product.title) + '" loading="lazy">'
        : '';
      var variantTitle = variant.title && variant.title !== 'Default Title' ? variant.title : '';

      return (
        '<div class="cu-opt" data-cu-variant="' + escapeHtml(variant.id) + '">' +
          '<div class="cu-opt__img">' + img + '</div>' +
          '<div class="cu-opt__info">' +
            '<div class="cu-opt__title">' + escapeHtml(product.title) + '</div>' +
            (variantTitle ? '<div class="cu-opt__variant">' + escapeHtml(variantTitle) + '</div>' : '') +
            '<div class="cu-opt__price" data-cu-price>' + escapeHtml(variant.price) + '</div>' +
          '</div>' +
          '<div class="cu-opt__action">' + renderAction(variant, 0) + '</div>' +
        '</div>'
      );
    };

    var setSheetMessage = function (message) {
      if (!sheet) return;
      var el = sheet.host.querySelector('[data-cu-msg]');
      if (el) el.textContent = message || '';
    };

    var openSheet = function (product, container) {
      closeSheet(true);

      var inDialog = container !== document.body;
      var host = document.createElement('div');
      host.className = 'cu-sheet-host' + (inDialog ? ' cu-sheet-host--in-dialog' : '');

      var rows = product.variants.map(function (v) {
        return renderRow(product, v);
      }).join('');

      host.innerHTML =
        '<div class="cu-sheet__backdrop" data-cu-close></div>' +
        '<div class="cu-sheet" role="dialog" aria-modal="true" aria-label="Choose option">' +
          '<div class="cu-sheet__header">' +
            '<button type="button" class="cu-sheet__icon-btn" data-cu-close aria-label="Back">' + ICON_BACK + '</button>' +
            '<div class="cu-sheet__titles">' +
              '<div class="cu-sheet__sub">' + escapeHtml(product.title) + '</div>' +
              '<div class="cu-sheet__title">Choose Option</div>' +
            '</div>' +
            '<button type="button" class="cu-sheet__icon-btn cu-sheet__close" data-cu-close aria-label="Close">' + ICON_CLOSE + '</button>' +
          '</div>' +
          '<div class="cu-sheet__list">' + rows + '</div>' +
          '<div class="cu-sheet__footer">' +
            '<div class="cu-sheet__msg" data-cu-msg aria-live="polite"></div>' +
            '<button type="button" class="cu-sheet__confirm" data-cu-confirm>Confirm</button>' +
          '</div>' +
        '</div>';

      container.appendChild(host);
      sheet = { host: host, product: product, selection: {}, container: container };

      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          host.classList.add('is-open');
        });
      });

      var closeBtn = host.querySelector('.cu-sheet__close');
      if (closeBtn) {
        try { closeBtn.focus({ preventScroll: true }); } catch (err) {}
      }
    };

    var closeSheet = function (immediate) {
      if (!sheet) return;
      var host = sheet.host;
      sheet = null;

      if (immediate) {
        host.remove();
        return;
      }

      host.classList.remove('is-open');
      window.setTimeout(function () {
        host.remove();
      }, 260);
    };

    var confirmSheet = function () {
      if (!sheet) return;

      var selection = sheet.selection;
      var items = Object.keys(selection).map(function (id) {
        return { id: Number(id), quantity: selection[id] };
      });

      if (!items.length) {
        setSheetMessage('Please add at least one option.');
        return;
      }

      var container = sheet.container;
      var btn = sheet.host.querySelector('[data-cu-confirm]');
      btn.disabled = true;
      btn.textContent = 'Adding…';
      setSheetMessage('');

      addItems(items)
        .then(function (data) {
          closeSheet();
          return refreshCart(data);
        })
        .then(function () {
          showToast(container, 'Added to cart');
        })
        .catch(function (err) {
          var message = (err && err.message) || 'Could not add to cart.';
          if (sheet && btn.isConnected) {
            btn.disabled = false;
            btn.textContent = 'Confirm';
            setSheetMessage(message);
          } else {
            showToast(container, message, true);
          }
        });
    };

    var onSheetClick = function (e) {
      // Taps inside the sheet must never reach the cart drawer's own
      // "click outside -> close drawer" handlers.
      e.stopPropagation();

      if (!sheet) return;

      if (e.target.closest('[data-cu-close]')) {
        e.preventDefault();
        closeSheet();
        return;
      }

      var row = e.target.closest('[data-cu-variant]');
      var addBtn = e.target.closest('[data-cu-opt-add]');
      var stepBtn = e.target.closest('[data-cu-step]');

      if (row && (addBtn || stepBtn)) {
        e.preventDefault();

        var id = row.getAttribute('data-cu-variant');
        var variant = findVariant(id);
        if (!variant || !variant.available) return;

        var max = Math.max(1, Number(variant.max) || 99);
        var current = sheet.selection[id] || 0;
        var next = addBtn ? 1 : current + Number(stepBtn.getAttribute('data-cu-step'));

        if (next > max) {
          next = max;
          setSheetMessage('Only ' + max + ' available for this option.');
        } else {
          setSheetMessage('');
        }

        if (next <= 0) {
          delete sheet.selection[id];
        } else {
          sheet.selection[id] = next;
        }

        // Redraw AFTER this click finishes. Replacing the tapped button
        // mid-click detaches it, and the drawer then thinks the tap was
        // "outside" and closes itself.
        var qtyNow = sheet.selection[id] || 0;
        var html = renderAction(variant, qtyNow);
        var priceText = linePriceText(variant, qtyNow);
        var actionEl = row.querySelector('.cu-opt__action');
        var priceEl = row.querySelector('[data-cu-price]');
        window.setTimeout(function () {
          if (actionEl && actionEl.isConnected) actionEl.innerHTML = html;
          if (priceEl && priceEl.isConnected) priceEl.textContent = priceText;
        }, 0);
        return;
      }

      if (e.target.closest('[data-cu-confirm]')) {
        e.preventDefault();
        confirmSheet();
      }
    };

    // Escape closes only the sheet, not the whole cart drawer.
    window.addEventListener('keydown', function (e) {
      if (!sheet || e.key !== 'Escape') return;
      e.preventDefault();
      e.stopImmediatePropagation();
      closeSheet();
    }, true);

    // ---------- Slider arrows ----------
    var observedSliders = typeof WeakSet === 'function' ? new WeakSet() : null;
    var resizeObserver = typeof ResizeObserver === 'function'
      ? new ResizeObserver(function () { scheduleArrows(); })
      : null;

    var syncArrows = function () {
      document.querySelectorAll('[data-upsell-slider]').forEach(function (slider) {
        if (resizeObserver && observedSliders && !observedSliders.has(slider)) {
          observedSliders.add(slider);
          resizeObserver.observe(slider);
        }

        var wrap = slider.parentElement;
        var prev = wrap.querySelector('[data-upsell-arrow="-1"]');
        var next = wrap.querySelector('[data-upsell-arrow="1"]');
        var maxScroll = slider.scrollWidth - slider.clientWidth;

        if (prev) prev.hidden = slider.scrollLeft <= 4;
        if (next) next.hidden = maxScroll <= 4 || slider.scrollLeft >= maxScroll - 4;
      });
    };

    var arrowFrame = null;
    function scheduleArrows() {
      if (arrowFrame) return;
      arrowFrame = window.requestAnimationFrame(function () {
        arrowFrame = null;
        syncArrows();
      });
    }

    document.addEventListener('scroll', function (e) {
      if (e.target && e.target.matches && e.target.matches('[data-upsell-slider]')) scheduleArrows();
    }, true);

    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes.length) {
          scheduleArrows();
          return;
        }
      }
    }).observe(document.body, { childList: true, subtree: true });

    // ---------- Event routing (v5) ----------
    // Handled on `window` in the CAPTURE phase, i.e. before ANY theme
    // script sees the tap. The cart drawer has its own "tap outside ->
    // close" / swipe-to-close logic; taps on the upsell, the arrows and
    // the Choose Option sheet are stopped here, so the drawer never
    // reacts to them and stays open.
    var isUpsellTarget = function (target) {
      return !!(target && target.closest && (
        target.closest('.cu-sheet-host') ||
        target.closest('[data-upsell-add]') ||
        target.closest('[data-upsell-arrow]')
      ));
    };

    ['pointerdown', 'pointerup', 'mousedown', 'mouseup', 'touchstart', 'touchend'].forEach(function (type) {
      window.addEventListener(type, function (e) {
        if (isUpsellTarget(e.target)) e.stopPropagation();
      }, { capture: true, passive: true });
    });

    window.addEventListener('click', function (e) {
      var target = e.target;
      if (!target || !target.closest) return;

      if (target.closest('.cu-sheet-host')) {
        e.stopPropagation();
        onSheetClick(e);
        return;
      }

      var addBtn = target.closest('[data-upsell-add]');
      if (addBtn) {
        e.preventDefault();
        e.stopPropagation();
        if (!addBtn.disabled) {
          window.setTimeout(function () {
            handleCardAdd(addBtn);
          }, 0);
        }
        return;
      }

      var arrow = target.closest('[data-upsell-arrow]');
      if (arrow) {
        e.preventDefault();
        e.stopPropagation();
        var slider = arrow.parentElement.querySelector('[data-upsell-slider]');
        if (!slider) return;
        var card = slider.querySelector('.cu-card');
        var step = card ? card.getBoundingClientRect().width + 16 : slider.clientWidth * 0.8;
        slider.scrollBy({ left: step * Number(arrow.getAttribute('data-upsell-arrow')), behavior: 'smooth' });
      }
    }, true);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scheduleArrows);
    } else {
      scheduleArrows();
    }
  })();

  /*
   * MOBILE BACK / BFCACHE SAFETY V7
   *
   * Some mobile browsers restore a Shopify dialog together with the document's
   * old scroll lock. The first back can look fine, but opening the cart again
   * and swiping back may leave html/body locked on the second BFCache restore.
   * Clean the lock both before the page is cached and after it is restored.
   *
   * V6 FIX: V5 only cleared the lock on document.documentElement and
   * document.body. But per this file's own CSS, .cart-drawer__content is
   * "the ONE REAL SCROLL CONTAINER" for vertical scrolling inside the
   * drawer — html/body are not what actually scrolls. If a BFCache
   * restore leaves a stale inline style or a stuck touch-action on
   * .cart-drawer__content (or on the <scroll-hint> custom element
   * wrapping .cart-drawer__items), vertical scrolling breaks while
   * horizontal sliders elsewhere on the page (.lc-uslider,
   * .cart-coupons__scroll — separate, self-contained overflow-x boxes
   * that were never part of any lock) keep working fine.
   *
   * V7 FIX: swipe-back closing the drawer turned out NOT to be a
   * pageshow/pagehide/BFCache situation at all in practice — closing
   * the drawer normally (tap the close button) worked fine, but
   * swipe-back specifically stayed broken even after V6. That points
   * to the drawer being closed via a `popstate` event (many cart
   * drawers push a history entry on open specifically so back/swipe
   * closes the drawer instead of navigating away), which never fires
   * pageshow or pagehide since the page itself never unloads or gets
   * BFCache-restored. V7 adds a direct `popstate` listener that runs
   * the same recovery regardless of how the drawer's own close logic
   * is wired.
   */
  (function () {
    if (window.__cartDrawerScrollRecoveryV7) return;
    window.__cartDrawerScrollRecoveryV7 = true;

    function getScrollTargets() {
      var targets = [document.documentElement, document.body];

      var content = document.querySelector('.cart-drawer__content');
      if (content) targets.push(content);

      var items = document.querySelector('scroll-hint.cart-drawer__items, .cart-drawer__items');
      if (items) targets.push(items);

      return targets;
    }

    function clearPageScrollLock() {
      var targets = getScrollTargets();

      targets.forEach(function (el) {
        if (!el) return;
        [
          'overflow', 'overflow-y', 'overflow-x',
          'position', 'touch-action', 'overscroll-behavior',
          'overscroll-behavior-y', 'overscroll-behavior-x',
          'pointer-events', 'height', 'max-height'
        ].forEach(function (prop) {
          el.style.removeProperty(prop);
        });

        el.classList.remove('overflow-hidden', 'scroll-locked', 'no-scroll');
      });

      // Re-assert the drawer's own scroll container as scrollable —
      // don't just remove inline styles and hope the stylesheet rule
      // wins; on some mobile browsers a BFCache restore keeps the
      // compositor's stale "this layer doesn't scroll" state until an
      // element's OWN scrolling properties are actively re-written.
      var content = document.querySelector('.cart-drawer__content');
      if (content) {
        content.style.overflowY = 'auto';
        content.style.overflowX = 'hidden';
        content.style.webkitOverflowScrolling = 'touch';
        content.style.touchAction = 'pan-y';
        // Force a reflow so the browser recalculates scrollability
        // immediately instead of on the next unrelated layout pass.
        void content.offsetHeight;
      }

      var items = document.querySelector('scroll-hint.cart-drawer__items, .cart-drawer__items');
      if (items) {
        items.style.touchAction = 'pan-y';
        void items.offsetHeight;
      }
    }

    function closeStaleCartDrawer() {
      var drawer = document.querySelector('cart-drawer');
      if (!drawer) return;

      try {
        if (typeof drawer.close === 'function') drawer.close();
      } catch (e) {}

      var dialog = drawer.querySelector('dialog[open]');
      if (dialog && typeof dialog.close === 'function') {
        try { dialog.close(); } catch (e) {}
      }

      // Some theme versions keep an open attribute/class briefly after close().
      if (dialog) dialog.removeAttribute('open');
      drawer.removeAttribute('open');
    }

    function recoverPageScroll() {
      clearPageScrollLock();
      window.setTimeout(clearPageScrollLock, 30);
      window.setTimeout(clearPageScrollLock, 120);
      window.setTimeout(clearPageScrollLock, 300);
      window.setTimeout(function () {
        window.dispatchEvent(new Event('resize'));
        window.dispatchEvent(new Event('scroll'));
      }, 60);
    }

    function onPageShow(event) {
      if (event && event.persisted) {
        closeStaleCartDrawer();
        recoverPageScroll();
        return;
      }

      // A normal history return can also restore a stale lock in some Chrome
      // versions, so only clear it when the cart is not currently open.
      var openDialog = document.querySelector('cart-drawer dialog[open]');
      if (!openDialog) recoverPageScroll();
    }

    function onPageHide(event) {
      if (!event || !event.persisted) return;
      // Release the lock BEFORE BFCache snapshots the page. This prevents the
      // second swipe-back from restoring a frozen vertical scroll surface.
      closeStaleCartDrawer();
      clearPageScrollLock();
    }

    window.addEventListener('pageshow', onPageShow, false);
    window.addEventListener('pagehide', onPageHide, false);

    // V7 FIX: swipe-back on mobile (and a plain tap of the hardware/
    // browser back button) very likely closes this drawer through a
    // `popstate` event, not a real page unload — many cart drawers push
    // a history entry when they open specifically so back/swipe closes
    // the drawer instead of navigating away. That path NEVER fires
    // pageshow or pagehide (the page never actually unloads or gets
    // BFCache-restored — it's a same-page history pop), so everything
    // above this line simply never ran for that case. This is why a
    // normal tap on the close button worked fine (it goes through
    // whatever in-page close logic already cleans up correctly) while
    // swipe-back specifically stayed broken. Clearing the lock here,
    // directly on popstate, covers that gap regardless of how the
    // drawer's own close logic is wired.
    //
    // V8 FIX: the on-screen debug panel confirmed the actual cause —
    // document.body is left with `position: fixed` after a real
    // swipe-back (the standard technique for locking the background
    // page while a drawer is open, normally undone by whatever code
    // closes the drawer — which the popstate path skips).
    //
    // V9 FIX: real-device testing showed the FIRST swipe-back still
    // froze scroll, but a SECOND swipe-back fixed it. That means the
    // V8 correction was landing too early and too briefly — either the
    // theme's own closing animation/cleanup takes longer than V8's
    // 1.5s window and re-imposes the lock again right after V8 gave up,
    // or the actual trigger is an attribute change on <cart-drawer>
    // itself (a `body:has(cart-drawer[open]) { position: fixed }`-style
    // rule is common in modern themes) rather than a mutation on body
    // directly, which V8's body-only MutationObserver would never see.
    // Two changes:
    // 1) Watch attribute changes anywhere in the document (not just on
    //    body) — this catches an [open] attribute or class toggling on
    //    <cart-drawer>, <dialog>, or any wrapper, regardless of which
    //    element the theme actually flips.
    // 2) Replace the handful of fixed-delay checkpoints with a tight
    //    100ms polling loop that keeps fighting for a full 5 seconds
    //    after popstate — long enough to outlast any slow real-device
    //    closing animation — instead of guessing an exact timing.
    var popstateGuardUntil = 0;
    var popstatePollTimer = null;

    function stripBodyFixedLock() {
      // Check BOTH <html> and <body> — in most browsers, <html>
      // (document.documentElement) is the element that actually
      // controls page-level scrolling, not <body>. A screenshot showed
      // body correctly reset to position:static after a swipe-back,
      // yet the page still wouldn't scroll — which only makes sense if
      // the real lock is sitting on <html> instead, and this function
      // was never checking that element at all until now.
      [document.documentElement, document.body].forEach(function (el) {
        if (!el) return;

        var computedPosition = window.getComputedStyle(el).position;
        var computedOverflowY = window.getComputedStyle(el).overflowY;

        if (
          el.style.position === 'fixed' || computedPosition === 'fixed' ||
          computedOverflowY === 'hidden'
        ) {
          // Force-override with !important so this wins regardless of
          // where the lock is actually coming from (inline style, CSS
          // class, or a :has()-style rule reacting to another element).
          el.style.setProperty('position', 'static', 'important');
          el.style.setProperty('top', 'auto', 'important');
          el.style.setProperty('left', 'auto', 'important');
          el.style.setProperty('width', 'auto', 'important');
          el.style.setProperty('overflow', 'visible', 'important');
          el.style.setProperty('overflow-y', 'auto', 'important');
          el.style.setProperty('height', 'auto', 'important');
        }
      });
    }

    // Watches the WHOLE document, not just body, so it catches whatever
    // element actually triggers the lock (an [open] attribute or class
    // toggling on <cart-drawer> or similar), even if body itself is
    // never directly mutated.
    var bodyLockObserver = new MutationObserver(function () {
      if (Date.now() > popstateGuardUntil) return;
      stripBodyFixedLock();
    });

    bodyLockObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['style', 'class', 'open'],
      subtree: true
    });

    window.addEventListener('popstate', function () {
      popstateGuardUntil = Date.now() + 5000;

      // Run immediately, don't wait for the first poll tick.
      clearPageScrollLock();
      stripBodyFixedLock();

      if (popstatePollTimer) window.clearInterval(popstatePollTimer);

      popstatePollTimer = window.setInterval(function () {
        if (Date.now() > popstateGuardUntil) {
          window.clearInterval(popstatePollTimer);
          popstatePollTimer = null;
          return;
        }
        stripBodyFixedLock();
      }, 100);

      // Still run the fuller cleanup (drawer content, scroll-hint, etc.)
      // at a few checkpoints too, not just the body-position fight.
      window.setTimeout(clearPageScrollLock, 300);
      window.setTimeout(clearPageScrollLock, 1000);
      window.setTimeout(clearPageScrollLock, 2500);
      window.setTimeout(clearPageScrollLock, 4900);
    }, false);

    // Chrome/iOS can restore the page through visibility changes without a
    // conventional pageshow in a few navigation paths.
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') {
        window.setTimeout(function () {
          var openDialog = document.querySelector('cart-drawer dialog[open]');
          if (!openDialog) recoverPageScroll();
        }, 50);
      }
    }, false);

    // Also cover the in-page case: closing the cart drawer normally
    // (tap the close button / backdrop) rather than via browser back.
    // If a previous swipe-back left a lock behind, it can otherwise
    // persist silently until the NEXT full page navigation.
    document.addEventListener('click', function (e) {
      if (e.target.closest('.cart-drawer__close-button, [data-cart-drawer-close]')) {
        window.setTimeout(clearPageScrollLock, 250);
      }
    }, false);
  })();
  } catch(e) { console.error(e); }
})();

})();
